import { createHandlerChainRunner, Handler, HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { get } from "@insite/client-framework/Services/ApiService";

export interface EcwOAuthResponse {
    accessToken: string;
    scope: string;
    clientId: string;
    clientSecret: string;
    properties: Record<string, string>;
}

type Parameter = HasOnSuccess<EcwOAuthResponse> & HasOnError<string>;

type HandlerType = Handler<Parameter, { apiResult: EcwOAuthResponse }>;

export const DispatchBeginLoadEcwAuthentication: HandlerType = props => {
    props.dispatch({
        type: "Widgets/ExemptionCertificateWizard/BeginLoadAuthentication",
    });
};

export const RequestEcwAuthentication: HandlerType = async props => {
    try {
        props.apiResult = await get<EcwOAuthResponse>("/api/v1/vertex/oauth/ecw");
    } catch (error) {
        props.dispatch({
            type: "Widgets/ExemptionCertificateWizard/FailLoadAuthentication",
            error: error instanceof Error ? error.message : "Failed to load ECW authentication",
        });
        props.parameter.onError?.(error instanceof Error ? error.message : "Failed to load ECW authentication");
        return false;
    }
};

export const DispatchCompleteLoadEcwAuthentication: HandlerType = props => {
    props.dispatch({
        type: "Widgets/ExemptionCertificateWizard/CompleteLoadAuthentication",
        result: props.apiResult,
    });
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [
    DispatchBeginLoadEcwAuthentication,
    RequestEcwAuthentication,
    DispatchCompleteLoadEcwAuthentication,
];

const loadEcwAuthentication = createHandlerChainRunner(chain, "LoadEcwAuthentication");
export default loadEcwAuthentication;
